import { GetServerSidePropsContext } from 'next'
import { NextRequest } from 'next/server'
import { AuthenticationError, ApplicationError } from '~/common/fetch'

export interface FetchOptions extends RequestInit {
  noContentType?: boolean
  baseUrl?: string
  nextRequest?: GetServerSidePropsContext<any>['req'] | NextRequest
  logTiming?: boolean
  disableRedirects?: boolean
}

export function isAccessDenied(error: Error | null | undefined | unknown) {
  return error instanceof AuthenticationError && error.status === 403
}

export function isNotFoundError(error: Error | null | undefined | unknown) {
  return error instanceof ApplicationError && error.status === 404
}
